<template>
  <div class="mso-chartOfAccounts responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'msoChartOfAccounts', label: 'MSO Chart of Account' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter"/>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "msoChartOfAccount",
  data() {
    return {
      listPageHeader,
      entity: Entities.MSOCHARTOFACCOUNT,
    };
  },
  mounted: function () {
    this.setPageTitle("MSOChartOfAccount");
  },
  components: {
    PageHeader,
    SearchTable,
  },
  computed: {
    ...mapGetters({
      sort: "msoChartOfAccountModule/sort",
      pagination: "msoChartOfAccountModule/pagination",
      initialFilter: "msoChartOfAccountModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "msoChartOfAccountModule/updateSort",
      updatePagination: "msoChartOfAccountModule/updatePagination",
      updateInitialFilter: "msoChartOfAccountModule/updateInitialFilter"
    }),
  }
};
</script>
